export const gridStyles = {
    // backgroundColor: "blue",
    // border: '1px solid green',
    paddingBottom: 2,
    paddingRight: 2,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%"
};
    
export const boxStyles = {
    borderColor: 'grey.300', 
    borderStyle: 'solid', 
    borderWidth: '0.1em', 
    marginBottom: 1,
    marginTop: 1
}
        